import React from 'react'
import { Trans } from '@lingui/macro'
import { Button } from 'components/UI/Button/Button'
import {
    PlusIcon
} from '@heroicons/react/outline'

// Type
export type typeDProductInfoActions = {
    onClickAdd?: () => void
    onClickImport?: () => void
    onClickExport: () => void
    onClickDeleteAll?: () => void
    onClickChangeVAT?: () => void
}


// Component
export const DProductInfoActions: React.FC<typeDProductInfoActions> = ({
                                                                           onClickAdd,
                                                                           onClickImport,
                                                                           onClickExport,
                                                                           onClickDeleteAll,
                                                                           onClickChangeVAT
                                                                       }) => {

    return (
        <>
            { !!onClickAdd &&
                <Button secondary={ true } buttonClassName="flex-initial" icon={ <PlusIcon className="w-5 h-5 mr-1"/> }
                        type="button" label={ <Trans>Add</Trans> } onClick={ () => onClickAdd() }/>
            }
            { !!onClickImport &&
                <Button secondary={ true } buttonClassName="flex-initial" type="button" label={ <Trans>Import</Trans> }
                        onClick={ () => onClickImport() }/>
            } <Button secondary={ true } buttonClassName="flex-initial" type="button" label={ <Trans>Export</Trans> }
                      onClick={ () => onClickExport() }/>

            { !!onClickChangeVAT && <Button secondary={ true } buttonClassName="flex-initial" type="button"
                                            label={ <Trans>Change VAT</Trans> } onClick={ () => onClickChangeVAT() }/> }

            { !!onClickDeleteAll && <Button secondary={ true } buttonClassName="flex-initial" type="button"
                                            label={ <Trans>Delete all products</Trans> }
                                            onClick={ () => onClickDeleteAll() }/>
            }</>
    )
}
